import React from 'react';
import classNames from 'classnames';

import './BurgerIcon.css';

export default function BurgerIcon(props) {
  return (
    <div className={classNames('burgerIcon', props.className, props.active && 'active')}>
      <span className="burgerIconBar burgerIconBarTop"></span>
      <span className="burgerIconBar burgerIconBarMiddle"></span>
      <span className="burgerIconBar burgerIconBarBottom"></span>
    </div>
  );
}
